import React from 'react';
import { Link } from 'react-router-dom';

const ResourcesSupportSection = () => {
  return (
    <div className="bg-white text-center flex-1 flex flex-col p-[40px] rounded-[20px] shadow-[0_15px_45px_rgba(0,0,0,0.2)] transition-transform duration-300 hover:-translate-y-[10px] hover:shadow-[0_20px_50px_rgba(0,0,0,0.25)]">
      <h2 className="text-texto-oscuro font-extrabold text-[2.2rem] mb-[15px]">Recursos y Apoyo</h2>
      <p className="text-texto-sec flex-grow text-base leading-[1.6] mb-[30px]">
        Encuentra todo lo que necesitas para tu bienestar y tu crecimiento personal y profesional.
      </p>
      <ul className="list-none p-0 text-left flex flex-col mx-0 mb-[30px] gap-[15px]">
        {[
          'Guías descargables y cápsulas de aprendizaje.',
          'Directorio de líneas de ayuda en Colombia.',
          'Convenios con universidades, ONGs y aliados.',
        ].map((item) => (
          <li key={item} className="relative text-base pl-[28px]">
            <span className="absolute left-0 text-icetex font-bold">✓</span>
            {item}
          </li>
        ))}
      </ul>
      <Link
        to="/recursos"
        className="bg-icetex text-white border-0 uppercase font-bold cursor-pointer no-underline inline-block py-[15px] px-[30px] rounded-[50px] text-[0.9rem] tracking-[0.5px] self-center shadow-[0_4px_15px_rgba(0,63,129,0.4)] transition-all duration-300 hover:bg-texto-oscuro hover:-translate-y-[3px]"
      >
        Accede a los recursos
      </Link>
    </div>
  );
};

export default ResourcesSupportSection;
